import type { PlayerProfile } from '@goodtime/engine';
import type { RoadRestoreResponse } from '@goodtime/shared';

/**
 * Take the balance a landmark restore answered with.
 *
 * A restore spends coins but isn't a bet: the server counts no XP for it.
 * A live wallet sync reads any drop in coins as a wager and counts it as XP
 * until it adopts the server's, which could flash a level-up during the
 * restore moment. So the balance is reconciled here without XP or the
 * zero-balance top-up, straight from the restore's answer (no second fetch).
 */
export function takeRestoredWallet(
  profile: Pick<PlayerProfile, 'reconcileBalance'>,
  res: Pick<RoadRestoreResponse, 'wallet'>,
): void {
  profile.reconcileBalance(res.wallet.coins);
}
